@if (initialized) {
  @if (!lineage.length) {
    <div class="mat-body-strong">
      No logs found
    </div>
  }
  <!-- List -->
  @if (lineage.length) {
    <div class="list">
      @for (line of lineage; track line) {
        <div class="list-item">
          <div>
            <b>{{line.state.comment}}</b>
            @if (line.actor?.id) {
              <span> by {{line.actor?.name}}</span>
            }
            <span> on {{line.created_at | dateFormat: 'very-long'}}</span>
          </div>
          @if (line.input?.formValues?.comments) {
            <div class="quote">{{line.input?.formValues?.comments}}</div>
          }
        </div>
      }
    </div>
  }
  <!-- List -->
  @if (pagination.length && lineage.length) {
    <mat-paginator (page)="pageChanged($event)"
      [length]="pagination.length" [pageIndex]="pagination.pageIndex" [pageSize]="pagination.pageSize">
    </mat-paginator>
  }
}
